import * as React from 'react';

import TabsComponent from '../../components/Tabs/Tabs';

export interface TabsProps {
  buttons: { text: string; href?: string }[];
}

const Tabs: React.SFC<TabsProps> = ({ buttons }) => <TabsComponent buttons={buttons} />;

export default Tabs;



// WEBPACK FOOTER //
// /www/client/src/containers/Tabs/Tabs.tsx